import React from 'react';
import { Helmet } from 'react-helmet';
import { DomainService } from '../../services/domain';
import { JentisConfig } from '../../types/configuration';

export const Jentis = (): JSX.Element => {
  const { domain, env, script }: JentisConfig = DomainService.getDomainSpecificJentisConfig();

  return (
    <Helmet>
      <script type="text/javascript">
        {`
                    (function(sCDN, sCDNProject, sCDNWorkspace, sCDNVers) {
                        if (window.localStorage !== null && typeof window.localStorage === "object" && typeof window.localStorage.getItem === "function" && window.sessionStorage !== null && typeof window.sessionStorage === "object" && typeof window.sessionStorage.getItem === "function") {
                            sCDNVers = window.sessionStorage.getItem('jts_preview_version') || window.localStorage.getItem('jts_preview_version') || sCDNVers;
                        }

                        window.jentis = window.jentis || {};
                        window.jentis.config = window.jentis.config || {};
                        window.jentis.config.frontend = window.jentis.config.frontend || {};
                        window.jentis.config.frontend.cdnhost = sCDN + "/get/" + sCDNWorkspace + "/web/" + sCDNVers + "/";
                        window.jentis.config.frontend.vers = sCDNVers;
                        window.jentis.config.frontend.env = sCDNWorkspace;
                        window.jentis.config.frontend.project = sCDNProject;
                        window._jts = window._jts || [];
                        
                        var f = document.getElementsByTagName("script")[0];
                        var j = document.createElement("script");
                        j.async = true;
                        j.src = window.jentis.config.frontend.cdnhost + "${script}.js";
                        f.parentNode.insertBefore(j, f)
                    })("${domain}", "${env}", "live", "_");

                    _jts.push({ track: "pageview" });
                    _jts.push({ track: "submit" });
                `}
      </script>
    </Helmet>
  );
};
